import React from "react";
import {connect} from "react-redux";
import ArchiveLink from "./ArchiveLink";
import {
    getArticleDateLong,
    getArticleOutletName,
    getArticleTitleRaw,
    getArticleAnchorId,
} from "../../../../redux/selectors/articles";
import {
    getCurrentArticleIdBeingScrolled,
    getCurrentArticleBeingScrolled,
    getUrlTemporaryId,
    getIsNavBarOpen,
} from "../../../../redux/selectors/navigation";
import {withRouter} from "react-router-dom";
import {convertAndFormatUTC} from "../../../../util/format";

/**
 * ouptut article formatted for aside/navigation list
 * @param  {} props
 * @param {Number} props.itemId - article "identifier" for the newsletter. it is not the actual article Id
 * @return {}
 */

class ArticleItem extends React.Component {
    constructor (props) {
        super(props);

        this.liRef = React.createRef();
    }

    componentDidUpdate() {
        const li = this.liRef.current;

        if (li) {
            if (this.props.itemIdBeingScrolled === this.props.itemId) {
                //const ul = li.offsetParent;

                li.scrollIntoView({behavior: "smooth", block: "center"});
            }
        }
    }

    /**
     * render content
     */
    render() {
        const {
            rawTitle,
            longDate,
            outletName,
            itemIdBeingScrolled,
            itemId,
            anchorId,
            temporaryId,
        } = this.props;

        const addClass = itemIdBeingScrolled === itemId ? "selected" : "";

        return (
            <li className="nav-item" ref={this.liRef}>
                <ArchiveLink
                    hash = {anchorId}
                    temporaryId = {temporaryId}
                    className = {`nav-article-link ${addClass}`}
                    title = {rawTitle}
                    formattedDate = {convertAndFormatUTC(longDate, "MMMM D, YYYY")}
                    outletName = {outletName} />
            </li>
        )
    }
}


// const ArticleItem = (props) => {
//     const {
//         rawTitle,
//         formattedDate,
//         outletName,
//         itemIdBeingScrolled,
//         itemId,
//         anchorId,
//         temporaryId,
//     } = props;

//     const addClass = itemIdBeingScrolled === itemId ? "selected" : "";

//     const liRef = React.createRef();

//     //if item being scrolled: get ref to li (domNode). get offsetParent. calculate scrollheight/call function in parent?

//     return (
//         <li className="nav-item" ref={liRef}>
//             <ArchiveLink
//                 hash = {anchorId}
//                 temporaryId = {temporaryId}
//                 className = {`nav-article-link ${addClass}`}
//                 title = {rawTitle}
//                 formattedDate = {formattedDate}
//                 outletName = {outletName} />
//         </li>
//     )
// };

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = (state, ownProps) => {
    const {itemId} = ownProps;

    return {
        rawTitle: getArticleTitleRaw(state, itemId),
        longDate: getArticleDateLong(state, itemId),
        outletName: getArticleOutletName(state, itemId),
        itemIdBeingScrolled: getCurrentArticleIdBeingScrolled(state, ownProps), // ownProps from react-router-dom because of withRouter
        anchorId: getArticleAnchorId(state, itemId),
        currentArticle: getCurrentArticleBeingScrolled(state, ownProps),
        temporaryId: getUrlTemporaryId(state),
        isNavOpen: getIsNavBarOpen(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ArticleItem));
